var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParticipantObserve = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  fill: "none",
  viewBox: "0 0 44 44"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 18,
  fill: "#6780AA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M32.818 22S28.363 15 22 15c-6.428 0-10.819 7-10.819 7S14.363 29 22 29c7.573 0 10.818-7 10.818-7m-6.364 0A4.426 4.426 0 0 1 22 26.454 4.426 4.426 0 0 1 17.546 22 4.426 4.426 0 0 1 22 17.546 4.426 4.426 0 0 1 26.454 22M22 23.91a1.909 1.909 0 1 1-.001-3.818 1.909 1.909 0 0 1 0 3.817",
  clipRule: "evenodd"
})));
export default SvgParticipantObserve;